'use client';

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className='flex min-h-[400px] w-full flex-col items-center justify-center p-4'>
      <div className='container mx-auto space-y-4 text-center'>
        <h2 className='text-2xl font-bold text-red-600'>
          Oops! Something went wrong
        </h2>
        <p className='text-gray-600'>Sorry, an error occurred in the page</p>
        <button
          onClick={() => reset()}
          className='rounded-md bg-red-600 px-4 py-2 text-white transition-colors duration-200 hover:bg-red-700'
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
